<template>
    <div class="container-fluid w-100 pb-3">
        <navbar :title="$t('menu.work_assignment')"/>
        <div class="col-12 d-flex justify-content-end">
          <button
            class="btn btn-outline-primary form-button"
            @click="toggleList"
          >
            {{ userAssignments ? $t('work_assignment.open_assignments') : $t('work_assignment.user_assignments') }}
          </button>
        </div>
    <div
      v-if="results && results.length > 0"
      class="col-sm-12 nopads"
    >
      <!-- Assignments -->
      <work-assignment-user-list
        :results="results"
        :user="user"
        @close-and-update="fetchAssignments"
      />
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import WorkAssignmentUserList from './WorkAssignmentUserList'
import {userHelper} from '../mixins/UserMixin'
import Navbar from "@/components/utils/Navbar";

export default {
    name: 'WorkAssignmentsUser',
    components: {Navbar, WorkAssignmentUserList},
    mixins: [restApi, userHelper],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            loading: true,
            userAssignments: true,
            results: []
        }
    },
    mounted: function () {
        this.fetchAssignments();
    },
    methods: {
        fetchAssignments: function () {
            this.results = []
            if (this.userAssignments) {
                this.fetchUserAssignments()
            } else {
                this.fetchUnassigned()
            }
        },
        toggleList: function () {
            this.userAssignments = !this.userAssignments
            this.fetchAssignments()
        },
        fetchUserAssignments: function () {
            this.loading = true
            this.restFetch(this.workAssignmentUserUrl, this.handleResponse)
        },
        fetchUnassigned: function () {
            this.loading = true
            this.restFetch(this.workAssignmentUnassignedUrl, this.handleResponse)
        },
        handleResponse: function (response) {
            if (response && response.status === 200) {
                this.results = response.data
            } else {
                this.error = 'Error'
            }
            this.loading = false
        }
    }
}
</script>
